import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import Body from 'syf-component-library/ui/typography/Body';
import { SyfLoader } from 'syf-component-library/ui/atoms';
import useSteps from '../../context/steps.context';
import RadioCard from '../../components/cards/RadioCard';
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { ReplacementCardReportLostStolenChatButton } from '../../components/Button';
import useTypesafeAnswer from '../../hooks/useTypesafeAnswer';
import useFeatureFlagsQuery from '../../hooks/useFeatureFlagsQuery';
import useAccountSummary from '../../hooks/useAccountSummary';
import { t } from '../../translations/getTranslation';
import spreadIf from '../../helpers/spreadIf';
import useCardEligibilityQuery from '../../hooks/useCardEligibility';
import theme from '../../theme';
import useConfig from '../../context/config.context';
import { useOTP } from '../../hoc/withAuth';
const Fieldset = styled.fieldset `
  all: unset;
`;
const LoadingWrapper = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const CustomRadioCard = styled(RadioCard) `
  margin-top: ${() => theme.spacing.base}px;
`;
const SubText = styled(Body) `
  margin-top: ${() => theme.spacing.large}px;
  text-align: center;
`;
const ReasonSelection = () => {
    const activeStep = 'ReasonSelection';
    const { currentAnswer } = useTypesafeAnswer(activeStep);
    const { triggerAnalyticsEvent } = useConfig();
    const { data: featureFlags } = useFeatureFlagsQuery();
    const { stepsState: { error }, stepsDispatch } = useSteps();
    const { isSuccess, isSemu } = useAccountSummary();
    const { isLoading: isEligibleCardLoading, error: eligibleCardError } = useCardEligibilityQuery();
    const { otpErrorCallbackParams, isLoading: isOtpLoading, error: otpError } = useOTP();
    const errorText = t('reasonSelection.makeASelection');
    const reasonOptions = [
        {
            headingKey: 'reasonSelection.damagedCardHeading',
            descriptionKey: 'reasonSelection.damagedCardBody',
            value: 'damaged-card'
        }
    ];
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showNeverReceived) {
        reasonOptions.push({
            headingKey: 'reasonSelection.neverReceivedCard',
            descriptionKey: 'reasonSelection.yourPreviouslyIssuedCard',
            value: 'never-received'
        });
    }
    useEffect(() => {
        if (!isSuccess || isEligibleCardLoading || eligibleCardError) {
            return;
        }
        triggerAnalyticsEvent({
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: 'replace your card',
            pageKind: 'account services',
            pageName: 'situation selection'
        });
    }, [
        triggerAnalyticsEvent,
        isSemu,
        isSuccess,
        isEligibleCardLoading,
        eligibleCardError
    ]);
    useEffect(() => {
        const removeSessionState = () => sessionStorage.removeItem('replacement-mfe_state');
        const restoredState = sessionStorage.getItem('replacement-mfe_state');
        /* State not available yet */
        if (!restoredState || isOtpLoading) {
            return;
        }
        /*
         * User wasn't authenticated and OTP didn't fail either
         * We assume the user just closed the tab or click the back arrow
         */
        if (otpError && !otpErrorCallbackParams) {
            removeSessionState();
            return;
        }
        const parsedState = JSON.parse(restoredState);
        stepsDispatch({ type: 'updateState', payload: parsedState });
        removeSessionState();
        /* eslint-disable-next-line */
    }, [isOtpLoading, otpError, otpErrorCallbackParams]);
    const handleReasonChange = (event) => {
        const reason = event.currentTarget.value;
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: activeStep, value: reason }
        });
    };
    const handleCardClick = (value) => {
        const reason = value;
        if (reason === (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value)) {
            return;
        }
        if (error) {
            stepsDispatch({ type: 'clearError' });
        }
        stepsDispatch({
            type: 'updateAnswer',
            payload: { step: activeStep, value: reason }
        });
    };
    if (isEligibleCardLoading || isOtpLoading)
        return (_jsx(LoadingWrapper, { children: _jsx(SyfLoader, { size: 4.375 }) }));
    return (_jsxs("div", Object.assign({ "data-cy": "reason-selection-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ maxWidth: 408 }, { children: [_jsxs(Fieldset, { children: [_jsx("legend", { children: _jsx(LayoutHeading, Object.assign({ title: t('reasonSelection.pleaseTellUsMore') }, spreadIf([error, { errorText }]))) }), reasonOptions.map(({ headingKey, descriptionKey, value }) => (_jsx(CustomRadioCard, { headingLabel: t(headingKey), description: t(descriptionKey), radioProps: {
                                    id: value,
                                    name: 'reason-selection',
                                    value,
                                    checked: (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value) === value,
                                    /* @ts-expect-error TODO: fix handle typing in CL. */
                                    onChange: handleReasonChange,
                                    children: null,
                                    hasError: !!error
                                }, onClick: () => handleCardClick(value) }, value)))] }), (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showLostCardText) && (_jsxs(SubText, { children: [t('reasonSelection.ifYouCantFind'), ' ', _jsx(ReplacementCardReportLostStolenChatButton, {}), "."] }))] }))] })));
};
export default ReasonSelection;
//# sourceMappingURL=index.js.map